module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      " + _vm._s(_vm.actionToBePerformed === 'Create Opportunity' ? 'Create Campaign' : 'Update Campaign') + "\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/opportunity-list"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create / Update Campaign")])])]), _vm._v(" "), _c('section', {
    staticClass: "content",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body oe-content-container"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12 oe-content-container"
  }, [_c('form', [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "content-step-one"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.opportunity_name),
      expression: "formDataObj.opportunity_name"
    }],
    staticClass: "form-control required",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.opportunity_name.required
    },
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "opportunity_name",
      "placeholder": "Campaign Name"
    },
    domProps: {
      "value": (_vm.formDataObj.opportunity_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "opportunity_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.opportunity_name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter campaign name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.country_id.required
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: (_vm.formDataObj.country_id),
      callback: function($$v) {
        _vm.$set(_vm.formDataObj, "country_id", $$v)
      },
      expression: "formDataObj.country_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose Country--")]), _vm._v(" "), _vm._l((_vm.clientCountries), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": value
      }
    }, [_vm._v("\n                            " + _vm._s(key) + "\n                          ")])
  })], 2), _vm._v(" "), ((_vm.submitted && !_vm.$v.formDataObj.country_id.required)) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a country.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('nv-select', {
    staticClass: "form-control required",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.customer_id.required
    },
    attrs: {
      "id": "Client"
    },
    model: {
      value: (_vm.formDataObj.customer_id),
      callback: function($$v) {
        _vm.$set(_vm.formDataObj, "customer_id", $$v)
      },
      expression: "formDataObj.customer_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Customer--")]), _vm._v(" "), _vm._l((_vm.filteredClientList), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.name) + "\n                          ")])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.customer_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a customer.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Opportunity Type"
    }
  }, [_vm._v("Campaign Type")]), _vm._v(" "), _vm._l((_vm.opportunityTypeOptions), function(opportunityTypeOption) {
    return _c('div', {
      key: opportunityTypeOption.value
    }, [_c('label', {
      staticClass: "radio-inline col-xs-4 col-sm-4 col-md-4 col-lg-4",
      class: {
        'reengagement-group-disabled': _vm.isOETypeDisabled
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.opportunityType),
        expression: "opportunityType"
      }],
      attrs: {
        "type": "radio",
        "disabled": _vm.isOETypeDisabled
      },
      domProps: {
        "value": opportunityTypeOption.value,
        "checked": _vm._q(_vm.opportunityType, opportunityTypeOption.value)
      },
      on: {
        "change": [function($event) {
          _vm.opportunityType = opportunityTypeOption.value
        }, _vm.onOpportunityTypeChange]
      }
    }), _vm._v(_vm._s(opportunityTypeOption.label) + "\n                          ")])])
  })], 2)]), _vm._v(" "), (!_vm.isInSessionOE) ? _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Campaign Goal"
    }
  }, [_vm._v("Campaign Goal (Went to destination)")]), _vm._v(" "), _c('div', {
    staticClass: "v-autocomplete"
  }, [_c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.destination_conversation.required
    },
    attrs: {
      "options": _vm.conversationList,
      "placeholder": "--Choose Campaign Goal--",
      "multiple": false
    },
    model: {
      value: (_vm.formDataObj.destination_conversation),
      callback: function($$v) {
        _vm.$set(_vm.formDataObj, "destination_conversation", $$v)
      },
      expression: "formDataObj.destination_conversation"
    }
  }), _vm._v(" "), ((_vm.submitted && !_vm.$v.formDataObj.destination_conversation.required)) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a destination")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.isNewUserBatch),
      expression: "formDataObj.isNewUserBatch"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formDataObj.isNewUserBatch) ? _vm._i(_vm.formDataObj.isNewUserBatch, null) > -1 : (_vm.formDataObj.isNewUserBatch)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formDataObj.isNewUserBatch,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formDataObj, "isNewUserBatch", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formDataObj, "isNewUserBatch", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formDataObj, "isNewUserBatch", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("is New User Batch")]), _vm._v(" "), _vm._m(2)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "content-step-two"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6",
    staticStyle: {
      "z-index": "10"
    }
  }, [_c('nv-select', {
    staticClass: "form-control required",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.audience_id.required
    },
    attrs: {
      "disabled": !!_vm.formDataObj.conversation_id,
      "id": "audience-type-builder"
    },
    on: {
      "change": _vm.updateAudienceType
    },
    model: {
      value: (_vm.formDataObj.audience_id),
      callback: function($$v) {
        _vm.$set(_vm.formDataObj, "audience_id", $$v)
      },
      expression: "formDataObj.audience_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose an Audience--")]), _vm._v(" "), _vm._l((_vm.filteredAudienceList), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.id
      }
    }, [_vm._v("\n                            " + _vm._s(data.query_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.audience_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an audience.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "audience-or-journey"
  }, [_vm._v("OR")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('nv-select', {
    staticClass: "form-control required",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.conversation_id.required
    },
    attrs: {
      "disabled": !!_vm.formDataObj.audience_id,
      "id": "audience-type-journey"
    },
    on: {
      "change": _vm.updateAudienceType
    },
    model: {
      value: (_vm.formDataObj.conversation_id),
      callback: function($$v) {
        _vm.$set(_vm.formDataObj, "conversation_id", $$v)
      },
      expression: "formDataObj.conversation_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a journey--")]), _vm._v(" "), _vm._l((_vm.journeyList), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.label) + "\n                          ")])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.conversation_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a journey.")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title style-title"
  }, [_vm._v("\n                    Step 3 | Create Message & Destination"), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), (_vm.turnCountry) ? _c('small', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Nudge templates from "), _c('b', [_vm._v(_vm._s(_vm.turnCountry))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "style-new-icon"
  }, [_c('i', {
    staticClass: "fa fa-gift",
    staticStyle: {
      "font-size": "22px"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "New Features!"
    },
    on: {
      "click": _vm.showInfoPopUp
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "hint-text"
  }, [_vm._v("If destination is keyword/conversation continue, make sure to add\n                        text like type 1, type 2 for different destination")])])]), _vm._v(" "), (_vm.isInSessionOE) ? _c('div', [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "content-step-three"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, _vm._l((_vm.splitOptions), function(splitOptn) {
    return _c('div', {
      key: splitOptn.value
    }, [_c('label', {
      staticClass: "radio-inline col-xs-4 col-sm-4 col-md-2 col-lg-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.split_type),
        expression: "split_type"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": splitOptn.value,
        "checked": _vm._q(_vm.split_type, splitOptn.value)
      },
      on: {
        "change": [function($event) {
          _vm.split_type = splitOptn.value
        }, _vm.onSplitTypeChange]
      }
    }), _vm._v(_vm._s(splitOptn.label) + "\n                            ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "margin-right": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-rounded btn-nudge",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Add New Group\n                          ")])])])]), _vm._v(" "), _vm._l((_vm.groupList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "panel panel-default panel-group-container"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('a', {
      staticClass: "collapsable-link-panel",
      attrs: {
        "href": '#content-group-' + index,
        "data-toggle": "collapse"
      }
    }, [_c('h3', {
      staticClass: "panel-title group-title"
    }, [_vm._v("Group " + _vm._s(index + 1) + "\n                              "), (_vm.actionToBePerformed !== 'Update Opportunity' && index) ? _c('div', {
      staticClass: "remove-group-btn-container",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.removeGroup(index)
        }
      }
    }, [_vm._m(4, true), _vm._v("\n                                Remove Group\n                              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body",
      attrs: {
        "id": 'content-group-' + index
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12"
    }, [(item.message && item.message.length) ? _c('div', {
      staticClass: "message-set-container"
    }, [_c('label', {
      attrs: {
        "for": "Message Sets"
      }
    }, [_vm._v("Message Set")]), _vm._v(" "), _c('table', {
      staticClass: "fixed-table"
    }, _vm._l((item.message), function(langObj, index) {
      return _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "message-country"
      }, [_c('h4', [_vm._v(_vm._s(langObj.country))])]), _vm._v(" "), _c('td', {
        staticClass: "message-language"
      }, [_c('h4', [_vm._v(_vm._s(langObj.language))])]), _vm._v(" "), _c('td', [_c('textarea-autosize', {
        staticClass: "form-control",
        staticStyle: {
          "min-height": "50px"
        },
        attrs: {
          "placeholder": "Enter the message"
        },
        model: {
          value: (langObj.message),
          callback: function($$v) {
            _vm.$set(langObj, "message", $$v)
          },
          expression: "langObj.message"
        }
      })], 1)])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-6"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('div', {
      staticClass: "destination-button",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary btn-rounded btn-nudge",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addDestination(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                                      Add Option\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12 col-lg-12 col-sm-12 col-xs-12",
      staticStyle: {
        "margin-left": "-30px",
        "margin-top": "-10px"
      }
    }, [((_vm.submitted && !item.destinationList.length)) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("Please\n                                      Choose at least one destination.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
    }, [_c('label', [_vm._v("Split (%)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.split_percent),
        expression: "item.split_percent"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submitted && (!_vm.$v.groupList.$each[index].split_percent.required || !_vm.$v.groupList.$each[index].split_percent.minValue || !_vm.$v.groupList.$each[index].split_percent.maxValue || !_vm.$v.groupList.$each[index].split_percent.numeric)
      },
      attrs: {
        "type": "text",
        "disabled": _vm.split_type === 'EQUAL',
        "autocomplete": "off",
        "id": "opportunity_name",
        "placeholder": "Split Percentage out of 100"
      },
      domProps: {
        "value": (item.split_percent)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "split_percent", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].split_percent.required) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter split percentage.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && (!_vm.$v.groupList.$each[index].split_percent.minValue || !_vm.$v.groupList.$each[index].split_percent.maxValue)) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter number between 0 to 100.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].split_percent.numeric) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter valid integer value.")]) : _vm._e()])])]), _vm._v(" "), _vm._l((item.destinationList), function(destination, destinationIndex) {
      return _c('div', {
        key: destinationIndex
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-12 col-lg-12 col-xs-12"
      }, [_c('div', {
        staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
      }, [_c('label', [_vm._v("Option Destination "), _c('span', {
        attrs: {
          "title": 'Please select only links OR (conversation & keyword) as destination option for single group'
        }
      }, [_c('i', {
        staticClass: "fa fa-info-circle margin-10"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
      }, [_c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (destination.destinationToUse),
          expression: "destination.destinationToUse"
        }],
        attrs: {
          "type": "radio",
          "value": "keyword",
          "name": 'destinationToUse' + index + '' + destinationIndex
        },
        domProps: {
          "checked": _vm._q(destination.destinationToUse, "keyword")
        },
        on: {
          "change": function($event) {
            return _vm.$set(destination, "destinationToUse", "keyword")
          }
        }
      }), _vm._v("Use Keyword\n                                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (destination.destinationToUse),
          expression: "destination.destinationToUse"
        }],
        attrs: {
          "type": "radio",
          "value": "destination_conversation",
          "name": 'destinationToUse' + index + '' + destinationIndex
        },
        domProps: {
          "checked": _vm._q(destination.destinationToUse, "destination_conversation")
        },
        on: {
          "change": function($event) {
            return _vm.$set(destination, "destinationToUse", "destination_conversation")
          }
        }
      }), _vm._v("Use\n                                        Conversation\n                                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (destination.destinationToUse),
          expression: "destination.destinationToUse"
        }],
        attrs: {
          "type": "radio",
          "value": "website_link",
          "name": 'destinationToUse' + index + '-' + destinationIndex
        },
        domProps: {
          "checked": _vm._q(destination.destinationToUse, "website_link")
        },
        on: {
          "change": function($event) {
            return _vm.$set(destination, "destinationToUse", "website_link")
          }
        }
      }), _vm._v("Website Link\n                                      ")])])])]), _vm._v(" "), ((item.destinationList.length > 1)) ? _c('div', {
        staticClass: "form-group col-xs-1 col-sm-1 col-md-1",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "remove-group-btn-container",
        staticStyle: {
          "direction": "rtl",
          "margin-right": "20px"
        }
      }, [_c('button', {
        staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.removeDestination(index, destinationIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-minus",
        attrs: {
          "aria-hidden": "true"
        }
      })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-6 col-lg-6 col-xs-6"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (destination.destinationToUse === 'keyword'),
          expression: "destination.destinationToUse === 'keyword'"
        }],
        staticClass: "form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "v-autocomplete"
      }, [_c('div', {
        staticClass: "reload-dbm"
      }, [_c('treeselect', {
        class: {
          'form-group--error': (_vm.submitted && _vm.isInSessionOE && destination.destinationToUse === 'keyword' && !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].keyword_id.required)
        },
        staticStyle: {
          "margin-right": "20px"
        },
        attrs: {
          "options": _vm.filteredKeywords,
          "placeholder": "--Choose a Keyword--",
          "multiple": false
        },
        on: {
          "select": function($event) {
            return _vm.onDestinationchange(item, destinationIndex)
          }
        },
        model: {
          value: (destination.keyword_id),
          callback: function($$v) {
            _vm.$set(destination, "keyword_id", $$v)
          },
          expression: "destination.keyword_id"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "refresh-conversation-keyword"
      }, [_c('a', {
        attrs: {
          "href": "#"
        }
      }, [_c('div', {
        staticClass: "fa fa-refresh rotate",
        attrs: {
          "title": "Click to refresh the contents of the list"
        },
        on: {
          "click": function($event) {
            return _vm.getConversationAndJourneysAndKeywords()
          }
        }
      })])])], 1)]), _vm._v(" "), ((_vm.submitted && _vm.isInSessionOE && destination.destinationToUse === 'keyword' && !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].keyword_id.required)) ? _c('span', {
        staticClass: "text-red pull-right"
      }, [_vm._v("Please\n                                      choose a keyword.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (destination.destinationToUse === 'destination_conversation'),
          expression: "destination.destinationToUse === 'destination_conversation'"
        }],
        staticClass: "form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "v-autocomplete"
      }, [_c('div', {
        staticClass: "reload-dbm-conversation"
      }, [_c('treeselect', {
        class: {
          'form-group--error': (_vm.submitted && _vm.isInSessionOE && destination.destinationToUse === 'destination_conversation' && !!_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].required)
        },
        attrs: {
          "options": _vm.conversationList,
          "placeholder": "--Choose a Conversation--",
          "multiple": false
        },
        on: {
          "select": function($event) {
            return _vm.onDestinationchange(item, destinationIndex)
          }
        },
        model: {
          value: (destination.conversation_id),
          callback: function($$v) {
            _vm.$set(destination, "conversation_id", $$v)
          },
          expression: "destination.conversation_id"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "refresh-conversation"
      }, [_c('a', {
        attrs: {
          "href": "#"
        }
      }, [_c('div', {
        staticClass: "fa fa-refresh rotate",
        attrs: {
          "title": "Click to refresh the contents of the list"
        },
        on: {
          "click": function($event) {
            return _vm.getConversationAndJourneysAndKeywords()
          }
        }
      })])])], 1)]), _vm._v(" "), ((_vm.submitted && _vm.isInSessionOE && destination.destinationToUse === 'destination_conversation' && !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].conversation_id.required)) ? _c('span', {
        staticClass: "text-red pull-right"
      }, [_vm._v("Please choose a conversation.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (destination.destinationToUse === 'website_link'),
          expression: "destination.destinationToUse === 'website_link'"
        }],
        staticClass: "form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('nv-select', {
        staticClass: "form-control",
        class: {
          'form-group--error': (_vm.submitted && _vm.isInSessionOE && destination.destinationToUse === 'website_link' && !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].website_link.required)
        },
        on: {
          "change": function($event) {
            return _vm.onDestinationchange(item, destinationIndex)
          }
        },
        model: {
          value: (destination.website_link),
          callback: function($$v) {
            _vm.$set(destination, "website_link", $$v)
          },
          expression: "destination.website_link"
        }
      }, [_c('option', {
        attrs: {
          "value": ""
        }
      }, [_vm._v("--Choose a Link--")]), _vm._v(" "), _vm._l((_vm.urlList), function(value, key) {
        return _c('option', {
          key: key,
          domProps: {
            "value": value.id
          }
        }, [_vm._v("\n                                        " + _vm._s(value.name) + "\n                                      ")])
      })], 2), _vm._v(" "), ((_vm.submitted && _vm.isInSessionOE && destination.destinationToUse === 'website_link' && !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].website_link.required)) ? _c('span', {
        staticClass: "text-red pull-right"
      }, [_vm._v("Please\n                                      choose website link.")]) : _vm._e()], 1)])])])])
    })], 2)])])
  })], 2)]) : _c('div', [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "content-step-three"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, _vm._l((_vm.splitOptions), function(splitOptn) {
    return _c('div', {
      key: splitOptn.value
    }, [_c('label', {
      staticClass: "radio-inline col-xs-4 col-sm-4 col-md-2 col-lg-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.split_type),
        expression: "split_type"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": splitOptn.value,
        "checked": _vm._q(_vm.split_type, splitOptn.value)
      },
      on: {
        "change": [function($event) {
          _vm.split_type = splitOptn.value
        }, _vm.onSplitTypeChange]
      }
    }), _vm._v(_vm._s(splitOptn.label) + "\n                            ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-rounded btn-nudge",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Add New Group\n                        ")])])])]), _vm._v(" "), _vm._l((_vm.groupList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "panel panel-default panel-group-container"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h3', {
      staticClass: "panel-title group-title"
    }, [_vm._v("Group " + _vm._s(index + 1) + "\n                              "), (_vm.actionToBePerformed !== 'Update Opportunity' && index) ? _c('div', {
      staticClass: "remove-group-btn-container"
    }, [_c('button', {
      staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                                Remove Group\n                            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body",
      attrs: {
        "id": 'content-group-' + index
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
    }, [_c('label', [_vm._v("Nudge")]), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "col-xs-10 col-sm-10 col-md-10",
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('treeselect', {
      class: {
        'form-group--error': _vm.submitted && (!_vm.$v.groupList.$each[index].msg_template_id.required || !_vm.checkIfNudgeConfigurationValid(item))
      },
      attrs: {
        "placeholder": "--Choose a nudge--",
        "multiple": false,
        "options": _vm.nudgesList
      },
      on: {
        "select": function($event) {
          return _vm.onNudgechange(item, item.msg_template_id)
        }
      },
      model: {
        value: (item.msg_template_id),
        callback: function($$v) {
          _vm.$set(item, "msg_template_id", $$v)
        },
        expression: "item.msg_template_id"
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].msg_template_id.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please choose a nudge.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.checkIfNudgeConfigurationValid(item)) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please configure dynamic nudge.")]) : _vm._e()], 1), _vm._v(" "), (item.msg_template_id) ? _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2",
      staticStyle: {
        "padding": "0px",
        "margin-left": "-15px"
      }
    }, [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onNudgePreviewClick(index, item.msg_template_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.isDynamicTemplate(item.msg_template_id) ? 'Configure' : 'Preview'))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
    }, [_c('label', [_vm._v("Split (%)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.split_percent),
        expression: "item.split_percent"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submitted && (!_vm.$v.groupList.$each[index].split_percent.required || !_vm.$v.groupList.$each[index].split_percent.minValue || !_vm.$v.groupList.$each[index].split_percent.maxValue || !_vm.$v.groupList.$each[index].split_percent.numeric)
      },
      attrs: {
        "type": "text",
        "disabled": _vm.split_type === 'EQUAL',
        "autocomplete": "off",
        "id": "opportunity_name",
        "placeholder": "Split Percentage out of 100"
      },
      domProps: {
        "value": (item.split_percent)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "split_percent", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].split_percent.required) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter split percentage.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && (!_vm.$v.groupList.$each[index].split_percent.minValue || !_vm.$v.groupList.$each[index].split_percent.maxValue)) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter number between 0 to 100.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].split_percent.numeric) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter valid integer value.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12",
      staticStyle: {
        "margin-left": "15px"
      }
    }, [_c('label', {
      staticClass: "checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_intermediate_message),
        expression: "item.is_intermediate_message"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.is_intermediate_message) ? _vm._i(item.is_intermediate_message, null) > -1 : (item.is_intermediate_message)
      },
      on: {
        "change": [function($event) {
          var $$a = item.is_intermediate_message,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "is_intermediate_message", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "is_intermediate_message", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "is_intermediate_message", $$c)
          }
        }, function($event) {
          return _vm.checkDestinationOptions(item.is_intermediate_message, item.destinationList)
        }]
      }
    }), _vm._v(" "), _c('b', [_vm._v("Present User With Another Question After Nudge")]), _vm._v(" "), _vm._m(5, true)])])]), _vm._v(" "), (item.message && item.message.length && item.is_intermediate_message) ? _c('div', {
      staticClass: "message-set-container"
    }, [_c('label', {
      attrs: {
        "for": "Message Sets"
      }
    }, [_vm._v("Message Set")]), _vm._v(" "), _c('table', {
      staticClass: "fixed-table"
    }, _vm._l((item.message), function(langObj, index) {
      return _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "message-country"
      }, [_c('h4', [_vm._v(_vm._s(langObj.country))])]), _vm._v(" "), _c('td', {
        staticClass: "message-language"
      }, [_c('h4', [_vm._v(_vm._s(langObj.language))])]), _vm._v(" "), _c('td', [_c('textarea-autosize', {
        staticClass: "form-control",
        staticStyle: {
          "min-height": "50px"
        },
        attrs: {
          "placeholder": "Enter the message"
        },
        model: {
          value: (langObj.message),
          callback: function($$v) {
            _vm.$set(langObj, "message", $$v)
          },
          expression: "langObj.message"
        }
      })], 1)])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-6"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('div', {
      staticClass: "destination-button",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary btn-rounded btn-nudge",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addDestination(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                                        Add Option\n                                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12 col-lg-12 col-sm-12 col-xs-12",
      staticStyle: {
        "margin-left": "-30px",
        "margin-top": "-10px"
      }
    }, [((_vm.submitted && !item.destinationList.length)) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("Please\n                                        Choose at least one destination.")]) : _vm._e()])])])])]), _vm._v(" "), _vm._l((item.destinationList), function(destination, destinationIndex) {
      return _c('div', {
        key: destinationIndex
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-12 col-lg-12 col-xs-12"
      }, [_c('div', {
        staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
      }, [_c('label', [_vm._v("Option Destination \n                                      "), _c('span', {
        attrs: {
          "title": 'Please select conversation or keyword as destination option for single group'
        }
      }, [_c('i', {
        staticClass: "fa fa-info-circle margin-10"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
      }, [_c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (destination.destinationToUse),
          expression: "destination.destinationToUse"
        }],
        attrs: {
          "type": "radio",
          "value": "keyword",
          "name": 'destinationToUse' + index + '' + destinationIndex
        },
        domProps: {
          "checked": _vm._q(destination.destinationToUse, "keyword")
        },
        on: {
          "change": function($event) {
            return _vm.$set(destination, "destinationToUse", "keyword")
          }
        }
      }), _vm._v("Use Keyword\n                                        ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (destination.destinationToUse),
          expression: "destination.destinationToUse"
        }],
        attrs: {
          "type": "radio",
          "value": "destination_conversation",
          "name": 'destinationToUse' + index + '' + destinationIndex
        },
        domProps: {
          "checked": _vm._q(destination.destinationToUse, "destination_conversation")
        },
        on: {
          "change": function($event) {
            return _vm.$set(destination, "destinationToUse", "destination_conversation")
          }
        }
      }), _vm._v("Use Conversation\n                                        ")])])])]), _vm._v(" "), ((item.destinationList.length > 1)) ? _c('div', {
        staticClass: "form-group col-xs-1 col-sm-1 col-md-1",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "remove-group-btn-container",
        staticStyle: {
          "direction": "rtl",
          "margin-right": "20px"
        }
      }, [_c('button', {
        staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.removeDestination(index, destinationIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-minus",
        attrs: {
          "aria-hidden": "true"
        }
      })])])]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-6 col-lg-6 col-xs-6"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (destination.destinationToUse === 'keyword'),
          expression: "destination.destinationToUse === 'keyword'"
        }],
        staticClass: "form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "v-autocomplete"
      }, [_c('div', {
        staticClass: "reload-dbm"
      }, [_c('treeselect', {
        class: {
          'form-group--error': (_vm.submitted && !_vm.isInSessionOE && destination.destinationToUse === 'keyword' &&
            !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].keyword_id.required)
        },
        attrs: {
          "options": _vm.filteredKeywords,
          "placeholder": "--Choose a Keyword--",
          "multiple": false
        },
        on: {
          "select": function($event) {
            return _vm.onDestinationchange(item, destinationIndex)
          }
        },
        model: {
          value: (destination.keyword_id),
          callback: function($$v) {
            _vm.$set(destination, "keyword_id", $$v)
          },
          expression: "destination.keyword_id"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "refresh-conversation-keyword"
      }, [_c('a', {
        attrs: {
          "href": "#"
        }
      }, [_c('div', {
        staticClass: "fa fa-refresh rotate",
        attrs: {
          "title": "Click to refresh the contents of the list"
        },
        on: {
          "click": function($event) {
            return _vm.getConversationAndJourneysAndKeywords()
          }
        }
      })])])], 1)]), _vm._v(" "), ((_vm.submitted && !_vm.isInSessionOE && destination.destinationToUse === 'keyword' && !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].keyword_id.required)) ? _c('span', {
        staticClass: "text-red pull-right"
      }, [_vm._v("Please\n                                          choose a keyword.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (destination.destinationToUse === 'destination_conversation'),
          expression: "destination.destinationToUse === 'destination_conversation'"
        }],
        staticClass: "form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "v-autocomplete"
      }, [_c('div', {
        staticClass: "reload-dbm-conversation"
      }, [_c('treeselect', {
        class: {
          'form-group--error': (_vm.submitted && !_vm.isInSessionOE && destination.destinationToUse === 'destination_conversation' &&
            !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].conversation_id.required)
        },
        attrs: {
          "options": _vm.conversationList,
          "placeholder": "--Choose a Conversation--",
          "multiple": false
        },
        on: {
          "select": function($event) {
            return _vm.onDestinationchange(item, destinationIndex)
          }
        },
        model: {
          value: (destination.conversation_id),
          callback: function($$v) {
            _vm.$set(destination, "conversation_id", $$v)
          },
          expression: "destination.conversation_id"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "refresh-conversation"
      }, [_c('a', {
        attrs: {
          "href": "#"
        }
      }, [_c('div', {
        staticClass: "fa fa-refresh rotate",
        attrs: {
          "title": "Click to refresh the contents of the list"
        },
        on: {
          "click": function($event) {
            return _vm.getConversationAndJourneysAndKeywords()
          }
        }
      })])])], 1)]), _vm._v(" "), ((_vm.submitted && !_vm.isInSessionOE && destination.destinationToUse === 'destination_conversation' &&
        !_vm.$v.groupList.$each[index].destinationList.$each[destinationIndex].conversation_id.required)) ? _c('span', {
        staticClass: "text-red pull-right"
      }, [_vm._v("Please choose a conversation.")]) : _vm._e()])])])])])])
    })], 2)])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(6), _vm._v(" "), (_vm.isInSessionOE) ? _c('div', [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "content-step-four"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleType),
      expression: "scheduleType"
    }],
    attrs: {
      "type": "radio",
      "value": "daterange",
      "name": "scheduleType"
    },
    domProps: {
      "checked": _vm._q(_vm.scheduleType, "daterange")
    },
    on: {
      "change": function($event) {
        _vm.scheduleType = "daterange"
      }
    }
  }), _vm._v("Date\n                              Range\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleType),
      expression: "scheduleType"
    }],
    attrs: {
      "type": "radio",
      "value": "activitycap",
      "name": "scheduleType"
    },
    domProps: {
      "checked": _vm._q(_vm.scheduleType, "activitycap")
    },
    on: {
      "change": function($event) {
        _vm.scheduleType = "activitycap"
      }
    }
  }), _vm._v("Activity\n                              Cap\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleType),
      expression: "scheduleType"
    }],
    attrs: {
      "type": "radio",
      "value": "activityStatus",
      "name": "scheduleType"
    },
    domProps: {
      "checked": _vm._q(_vm.scheduleType, "activityStatus")
    },
    on: {
      "change": function($event) {
        _vm.scheduleType = "activityStatus"
      }
    }
  }), _vm._v("Always\n                              On\n                            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scheduleType == 'daterange'),
      expression: "scheduleType=='daterange'"
    }],
    staticClass: "row",
    staticStyle: {
      "padding": "0 15px",
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.start_date),
      expression: "formDataObj.start_date"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.start_date.required && !_vm.formDataObj.start_date
    },
    attrs: {
      "type": "date",
      "max": _vm.formDataObj.end_date,
      "id": "date-from",
      "placeholder": "Select Start Date"
    },
    domProps: {
      "value": (_vm.formDataObj.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "start_date", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.start_date.required && !_vm.formDataObj.start_date) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please enter start date.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.end_date),
      expression: "formDataObj.end_date"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.end_date.required && !_vm.formDataObj.end_date
    },
    attrs: {
      "type": "date",
      "min": _vm.formDataObj.start_date,
      "id": "date-to",
      "placeholder": "Select End Date"
    },
    domProps: {
      "value": (_vm.formDataObj.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "end_date", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.end_date.required && !_vm.formDataObj.end_date) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please enter end date.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6"
  }, [(_vm.submitted && _vm.dateRangeRequired) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select\n                              date range.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scheduleType == 'activitycap'),
      expression: "scheduleType=='activitycap'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && _vm.activityCapChoiceRequired
    },
    attrs: {
      "multiple": false,
      "clearable": false,
      "options": _vm.inSessionThresholdOptions,
      "placeholder": "--Choose a Threshold---"
    },
    model: {
      value: (_vm.activityCapChoice),
      callback: function($$v) {
        _vm.activityCapChoice = $$v
      },
      expression: "activityCapChoice"
    }
  }), _vm._v(" "), (_vm.submitted && _vm.activityCapChoiceRequired) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please\n                                  choose a limit.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.threshold_limit),
      expression: "formDataObj.threshold_limit"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': (_vm.submitted && (!_vm.$v.formDataObj.threshold_limit.required || !_vm.$v.formDataObj.threshold_limit.minValue || !_vm.$v.formDataObj.threshold_limit.numeric))
    },
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "threshold_limit",
      "placeholder": "Enter Number"
    },
    domProps: {
      "value": (_vm.formDataObj.threshold_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "threshold_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.formDataObj.threshold_limit && !_vm.$v.formDataObj.threshold_limit.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter number.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && (!_vm.$v.formDataObj.threshold_limit.minValue || !_vm.$v.formDataObj.threshold_limit.numeric)) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please enter valid integer value.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scheduleType == 'activityStatus'),
      expression: "scheduleType=='activityStatus'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-inline form-group margin-left-20px"
  }, [_c('label', [_vm._v("Pause")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleactivityStatus),
      expression: "toggleactivityStatus"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggleactivityStatus) ? _vm._i(_vm.toggleactivityStatus, null) > -1 : (_vm.toggleactivityStatus)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toggleactivityStatus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggleactivityStatus = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggleactivityStatus = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggleactivityStatus = $$c
        }
      }, _vm.handleActivityToggle]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('label', [_vm._v("Active")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row form-control",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.recurrenceOptions), function(recurrence) {
    return _c('label', {
      key: recurrence.value,
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formDataObj.recurrence),
        expression: "formDataObj.recurrence"
      }],
      attrs: {
        "type": "radio",
        "disabled": _vm.scheduleType == 'activitycap'
      },
      domProps: {
        "value": recurrence.value,
        "checked": _vm._q(_vm.formDataObj.recurrence, recurrence.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.formDataObj, "recurrence", recurrence.value)
        }
      }
    }), _vm._v(_vm._s(recurrence.label) + "\n                              ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-inline form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendTime.hours),
      expression: "sendTime.hours"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "min": "0",
      "max": "23",
      "placeholder": "HH"
    },
    domProps: {
      "value": (_vm.sendTime.hours)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInactivityTime($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendTime, "hours", $event.target.value)
      }
    }
  }), _vm._v("\n                              hrs :\n                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendTime.minutes),
      expression: "sendTime.minutes"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "min": "0",
      "max": "59",
      "placeholder": "MM"
    },
    domProps: {
      "value": (_vm.sendTime.minutes)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInactivityTime($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendTime, "minutes", $event.target.value)
      }
    }
  }), _vm._v("\n                              mins\n                            ")]), _vm._v(" "), (_vm.submitted && _vm.isInvalidSendTime) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please enter valid timing")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.sendTime.hours && !_vm.sendTime.minutes) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please\n                              enter inactivity timing")]) : _vm._e()])])])])])]) : _c('div', [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "content-step-four"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row form-control",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.recurrenceOptions), function(recurrence) {
    return _c('label', {
      key: recurrence.value,
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formDataObj.recurrence),
        expression: "formDataObj.recurrence"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": recurrence.value,
        "checked": _vm._q(_vm.formDataObj.recurrence, recurrence.value)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.formDataObj, "recurrence", recurrence.value)
        }, _vm.onRecurrenceOptionChange]
      }
    }), _vm._v(_vm._s(recurrence.label) + "\n                              ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-3 col-sm-3 col-md-3"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "schedule period"
    }
  }, [_vm._v("Schedule Period")]), _vm._v(" "), _c('div', {
    staticClass: "row form-control",
    staticStyle: {
      "border": "none"
    }
  }, [_c('label', {
    staticClass: "radio-inline",
    class: {
      'reengagement-group-disabled': !_vm.scheduleType
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleType),
      expression: "scheduleType"
    }],
    attrs: {
      "disabled": _vm.formDataObj.recurrence === 'ONETIME',
      "type": "radio",
      "value": "daterange",
      "name": "scheduleType"
    },
    domProps: {
      "checked": _vm._q(_vm.scheduleType, "daterange")
    },
    on: {
      "change": function($event) {
        _vm.scheduleType = "daterange"
      }
    }
  }), _vm._v("Date Range\n                              ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    class: {
      'reengagement-group-disabled': !_vm.scheduleType
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleType),
      expression: "scheduleType"
    }],
    attrs: {
      "disabled": _vm.formDataObj.recurrence === 'ONETIME',
      "type": "radio",
      "value": "activityStatus",
      "name": "scheduleType"
    },
    domProps: {
      "checked": _vm._q(_vm.scheduleType, "activityStatus")
    },
    on: {
      "change": function($event) {
        _vm.scheduleType = "activityStatus"
      }
    }
  }), _vm._v("Always On\n                              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-xs-5 col-sm-5 col-md-5"
  }, [(_vm.formDataObj.recurrence === 'ONETIME') ? _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Deployment Date & Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.start_date),
      expression: "formDataObj.start_date"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.start_date.required && !_vm.formDataObj.start_date
    },
    attrs: {
      "type": "datetime-local",
      "id": "date-from",
      "placeholder": "Select Deployment Date"
    },
    domProps: {
      "value": (_vm.formDataObj.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "start_date", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.start_date.required && !_vm.formDataObj.start_date) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please enter deployment date.")]) : _vm._e()]) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scheduleType == 'daterange'),
      expression: "scheduleType=='daterange'"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Start Date & Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.start_date),
      expression: "formDataObj.start_date"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.start_date.required && !_vm.formDataObj.start_date
    },
    attrs: {
      "type": "datetime-local",
      "max": _vm.formDataObj.end_date,
      "id": "date-from",
      "placeholder": "Select Start Date"
    },
    domProps: {
      "value": (_vm.formDataObj.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "start_date", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.start_date.required && !_vm.formDataObj.start_date) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please enter start date.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin-left": "10px"
    }
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v("End Date & Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.end_date),
      expression: "formDataObj.end_date"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.formDataObj.end_date.required && !_vm.formDataObj.end_date
    },
    attrs: {
      "type": "datetime-local",
      "min": _vm.formDataObj.start_date,
      "id": "date-to",
      "placeholder": "Select End Date"
    },
    domProps: {
      "value": (_vm.formDataObj.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "end_date", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.end_date.required && !_vm.formDataObj.end_date) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please enter end date.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scheduleType == 'daterange'),
      expression: "scheduleType=='daterange'"
    }],
    staticClass: "col-xs-5 col-sm-5 col-md-5"
  }, [(_vm.submitted && _vm.dateRangeRequired) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select\n                                date range.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scheduleType == 'activityStatus'),
      expression: "scheduleType=='activityStatus'"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "activity-status"
    }
  }, [_vm._v("Status")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scheduleType == 'activityStatus'),
      expression: "scheduleType=='activityStatus'"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "form-inline form-group"
  }, [_c('label', [_vm._v("Pause")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleactivityStatus),
      expression: "toggleactivityStatus"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggleactivityStatus) ? _vm._i(_vm.toggleactivityStatus, null) > -1 : (_vm.toggleactivityStatus)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toggleactivityStatus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggleactivityStatus = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggleactivityStatus = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggleactivityStatus = $$c
        }
      }, _vm.handleActivityToggle]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('label', [_vm._v("Active")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-6 col-xs-6"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12",
    staticStyle: {
      "margin": "10px 0px"
    }
  }, [(_vm.formDataObj.recurrence !== 'ONETIME') ? _c('div', {
    staticClass: "col-lg-6 col-xs-6 col-sm-6 col-md-6",
    staticStyle: {
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "form-inline form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delay.quantity),
      expression: "delay.quantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "placeholder": "Delay"
    },
    domProps: {
      "value": (_vm.delay.quantity)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInactivityTime($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.delay, "quantity", $event.target.value)
      }
    }
  }), _vm._v("\n                               \n                              "), _c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "id": "input-type"
    },
    on: {
      "change": function($event) {
        return _vm.validateInactivityTime($event)
      }
    },
    model: {
      value: (_vm.delay.units),
      callback: function($$v) {
        _vm.$set(_vm.delay, "units", $$v)
      },
      expression: "delay.units"
    }
  }, [_c('option', {
    attrs: {
      "value": "hrs"
    }
  }, [_vm._v("hrs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "days"
    }
  }, [_vm._v("days")])]), _vm._v("\n                               \n                              "), _c('i', {
    staticClass: "fa fa-times-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.resetDelay()
      }
    }
  }), _vm._v("\n                                 \n                            ")], 1), _vm._v(" "), (_vm.submitted && _vm.isInvalidDelay) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Inactivity timing should be minimum 24 hrs or 1 day")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.delay.units && !_vm.delay.quantity) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please\n                              enter inactivity timing")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-6 col-sm-6 col-md-6",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_vm._m(11), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.last_reengage_days),
      expression: "formDataObj.last_reengage_days"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': (_vm.submitted && (!_vm.$v.formDataObj.last_reengage_days.numeric || !_vm.$v.formDataObj.last_reengage_days.minValue))
    },
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Enter Number"
    },
    domProps: {
      "value": (_vm.formDataObj.last_reengage_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "last_reengage_days", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.formDataObj.last_reengage_days.required) ? _c('span', {
    staticClass: "text-red pull-center"
  }, [_vm._v("Please enter number.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && (!_vm.$v.formDataObj.last_reengage_days.numeric || !_vm.$v.formDataObj.last_reengage_days.minValue)) ? _c('span', {
    staticClass: "text-red pull-center"
  }, [_vm._v("Please enter value greater than or equal to zero")]) : _vm._e()])])])]), _vm._v(" "), (_vm.formDataObj.recurrence !== 'ONETIME') ? _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-xs-12 col-sm-12 col-md-12"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.skip_upperbound),
      expression: "formDataObj.skip_upperbound"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formDataObj.skip_upperbound) ? _vm._i(_vm.formDataObj.skip_upperbound, null) > -1 : (_vm.formDataObj.skip_upperbound)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formDataObj.skip_upperbound,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formDataObj, "skip_upperbound", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formDataObj, "skip_upperbound", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formDataObj, "skip_upperbound", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(12)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-xs-12 col-sm-12 col-md-12",
    staticStyle: {
      "padding": "0px 15px",
      "margin-top": "15px",
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading campaign-goals-header"
  }, [_vm._m(13), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCampaignThresholdOn),
      expression: "isCampaignThresholdOn"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCampaignThresholdOn) ? _vm._i(_vm.isCampaignThresholdOn, null) > -1 : (_vm.isCampaignThresholdOn)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isCampaignThresholdOn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCampaignThresholdOn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCampaignThresholdOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCampaignThresholdOn = $$c
        }
      }, _vm.onThresholdSwitchChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "goals-container"
  }, [_c('div', {
    staticStyle: {
      "flex": "0.5"
    }
  }, [_c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.isInSessionOE && _vm.isCampaignThresholdOn && _vm.activityCapChoiceRequired
    },
    attrs: {
      "multiple": false,
      "clearable": false,
      "options": _vm.ooSsessionThresholdOptions.filter(function (item) { return item.recurrence_type === 'BOTH' || item.recurrence_type === _vm.formDataObj.recurrence; }),
      "disabled": !_vm.isCampaignThresholdOn,
      "placeholder": "--Choose a Threshold---"
    },
    model: {
      value: (_vm.selectedThreshold),
      callback: function($$v) {
        _vm.selectedThreshold = $$v
      },
      expression: "selectedThreshold"
    }
  }), _vm._v(" "), (_vm.submitted && _vm.isCampaignThresholdOn && !_vm.isInSessionOE && _vm.activityCapChoiceRequired) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a threshold")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px",
      "flex": "0.5"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataObj.threshold_limit),
      expression: "formDataObj.threshold_limit"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': (_vm.submitted && !_vm.isInSessionOE && (!_vm.$v.formDataObj.threshold_limit.required || !_vm.$v.formDataObj.threshold_limit.minValue || !_vm.$v.formDataObj.threshold_limit.numeric))
    },
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Enter Number",
      "disabled": !_vm.isCampaignThresholdOn
    },
    domProps: {
      "value": (_vm.formDataObj.threshold_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataObj, "threshold_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.isInSessionOE && !_vm.$v.formDataObj.threshold_limit.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter number.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.isInSessionOE && (!_vm.$v.formDataObj.threshold_limit.minValue || !_vm.$v.formDataObj.threshold_limit.numeric)) ? _c('span', {
    staticClass: "text-red pull-left"
  }, [_vm._v("Please enter valid integer value.")]) : _vm._e()])])])])])]), _vm._v(" "), (_vm.formDataObj.recurrence !== 'ONETIME') ? _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12",
    staticStyle: {
      "margin": "10px 0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_vm._m(14), _vm._v(" "), _c('div', [_c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "id": "input-type"
    },
    on: {
      "change": function($event) {
        return _vm.validateInactivityTime($event)
      }
    },
    model: {
      value: (_vm.formDataObj.max_nudge_per_user),
      callback: function($$v) {
        _vm.$set(_vm.formDataObj, "max_nudge_per_user", $$v)
      },
      expression: "formDataObj.max_nudge_per_user"
    }
  }, _vm._l((10), function(item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [(_vm.formDataObj.recurrence !== 'ONETIME') ? _c('div', {
    staticClass: "col-lg-12 col-xs-12 col-sm-12 col-md-12",
    staticStyle: {
      "padding": "0px 15px",
      "margin-top": "15px",
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading campaign-goals-header"
  }, [_c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "width": "calc( 100% - 50px)"
    }
  }, [_vm._v("\n                                Schedule on specific date (Optional)\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isScheduleDateOn),
      expression: "isScheduleDateOn"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isScheduleDateOn) ? _vm._i(_vm.isScheduleDateOn, null) > -1 : (_vm.isScheduleDateOn)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isScheduleDateOn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isScheduleDateOn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isScheduleDateOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isScheduleDateOn = $$c
        }
      }, _vm.onScheduleSwitchChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "10px",
      "margin-bottom": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-rounded",
    attrs: {
      "disabled": !_vm.isScheduleDateOn,
      "type": "button"
    },
    on: {
      "click": _vm.addSchedule
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Add new schedule \n                            ")]), _vm._v(" "), _vm._l((_vm.schedules), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dayAndTime"
    }, [_c('div', {
      staticClass: "form-group col-xs-5 col-lg-5 col-sm-5 col-md-5"
    }, [_c('label', [_vm._v("Select Day")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control required",
      class: {
        'form-group--error': _vm.submitted && _vm.isScheduleDateOn && !_vm.$v.schedules.$each[index].selectedDay.required
      },
      attrs: {
        "disabled": !_vm.isScheduleDateOn,
        "id": "audience-type-builder"
      },
      model: {
        value: (item.selectedDay),
        callback: function($$v) {
          _vm.$set(item, "selectedDay", $$v)
        },
        expression: "item.selectedDay"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Choose a Day--")]), _vm._v(" "), _vm._l((_vm.daysOfWeek), function(data, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": data
        }
      }, [_vm._v("\n                                    " + _vm._s(data))])
    })], 2), _vm._v(" "), (_vm.submitted && _vm.isScheduleDateOn && !_vm.$v.schedules.$each[index].selectedDay.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please choose a day.\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-5 col-lg-5 col-sm-5 col-md-5"
    }, [_c('label', [_vm._v("Select Time")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selectedTime),
        expression: "item.selectedTime"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submitted && _vm.isScheduleDateOn && !_vm.$v.schedules.$each[index].selectedTime.required
      },
      attrs: {
        "disabled": !_vm.isScheduleDateOn,
        "type": "time"
      },
      domProps: {
        "value": (item.selectedTime)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "selectedTime", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submitted && _vm.isScheduleDateOn && !_vm.$v.schedules.$each[index].selectedTime.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please choose a time.\n                                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-lg-2 col-sm-2 col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "disabled": !_vm.isScheduleDateOn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSchedule(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2)])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row oe-action-buttons"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkButtonVisibility('draft')),
      expression: "checkButtonVisibility('draft')"
    }],
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button",
      "value": _vm.formDataObj.opportunity_status === 0 ? 'SAVE' : 'SAVE AS DRAFT'
    },
    on: {
      "click": function($event) {
        return _vm.saveOpportunity('saveasdraft')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkButtonVisibility('deploy')),
      expression: "checkButtonVisibility('deploy')"
    }],
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button",
      "value": _vm.formDataObj.opportunity_status === 0 ? 'SAVE & DEPLOY' : 'SAVE'
    },
    on: {
      "click": function($event) {
        return _vm.saveOpportunity('saveanddeploy')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button",
      "value": "CANCEL"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  })])])])])])]), _vm._v(" "), (_vm.showNewFeaturePrompt) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal new-feature",
    staticStyle: {
      "height": "415px",
      "width": "518px"
    },
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "header-style"
  }, [_c('h3', [_vm._v("New Features !")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "22px",
      "color": "red"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeNewFeatureModal
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "style-section"
  }, [_vm._m(15), _vm._v(" "), _c('div', [_vm._v("We can now add buttons for message instead of asking the user to type the numbers.")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "style-select-options"
  }, [_vm._v("Please select one of the following options :- ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForButton))]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', [_vm._v("We can support lists instead of buttons whenever the user has more than 3 options to be selected.")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "style-select-options"
  }, [_vm._v("Please select one of the following options :- ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForList))]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('div', [_vm._v("We can support adding user's name dynamically.")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "style-select-options"
  }, [_vm._v("Hi " + _vm._s(_vm.showTextInfoForUserName) + ", hope you're doing fine ")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', [_vm._v("We can support adding provider's code dynamically.")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "style-select-options"
  }, [_vm._v("Hi " + _vm._s(_vm.showTextInfoForUserName) + ", time to fill up weekly referral report. Click at like http://ref.nivi.io/" + _vm._s(_vm.showTextInfoForProviderCode) + " }} ")])])])])]) : _vm._e()]), _vm._v(" "), (_vm.showNudgePreview) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px",
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "margin-bottom-10px"
    }, [(_vm.showCountryPicker) ? [_c('label', {
      staticClass: "required"
    }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      staticStyle: {
        "display": "inline-block",
        "min-width": "180px",
        "vertical-align": "middle",
        "margin-left": "8px"
      },
      on: {
        "change": function($event) {
          return _vm.onTurnCountryChange()
        }
      },
      model: {
        value: (_vm.turnCountry),
        callback: function($$v) {
          _vm.turnCountry = $$v
        },
        expression: "turnCountry"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("-- Select Country --")]), _vm._v(" "), _vm._l((_vm.turnCountryList), function(country) {
      return _c('option', {
        key: country,
        domProps: {
          "value": country
        }
      }, [_vm._v(_vm._s(country))])
    })], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px"
      }
    }, [_vm._v("Templates differ per country's Turn namespace. Select a country to load them.")])] : [_c('span', [_vm._v("Templates from "), _c('b', [_vm._v(_vm._s(_vm.turnCountry))])]), _vm._v(" "), (_vm.turnCountryList.length > 1) ? _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showCountryPicker = true
        }
      }
    }, [_vm._v("Change Country")]) : _vm._e()]], 2), _vm._v(" "), (_vm.turnCountry) ? _c('div', [_c('div', {
      staticClass: "nudge-origin-title"
    }, [_vm._v("WhatsApp Nudge(s):")]), _vm._v(" "), _vm._l((_vm.nudgePreviewData), function(data, index) {
      return _c('div', {
        key: 'nudge' + index,
        staticClass: "margin-bottom-10px"
      }, [_c('span', {
        staticClass: "nudge-language"
      }, [_vm._v(_vm._s(data.language) + " :")]), _vm._v(" "), (data.turn_template_data && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(data.turn_template_data.HEADER_FORMAT)) ? _c('div', {
        staticStyle: {
          "max-width": "260px"
        }
      }, [_c('media-preview', {
        attrs: {
          "format": data.turn_template_data.HEADER_FORMAT,
          "media-id": data.media_id,
          "media-name": data.media_name || '',
          "country-id": _vm.formDataObj.country_id || null,
          "language-id": data.language_id
        }
      })], 1) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.HEADER) ? _c('div', {
        staticClass: "nudge-whatsapp-header"
      }, [_vm._l((data.headerObj.text), function(part, index) {
        return _c('span', {
          key: 'header' + index
        }, [_vm._v("\n                  " + _vm._s(part)), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.headerObj.gaps[index]),
            expression: "data.headerObj.gaps[index]"
          }],
          staticStyle: {
            "width": "500px"
          },
          attrs: {
            "placeholder": "Enter text for header"
          },
          domProps: {
            "value": (data.headerObj.gaps[index])
          },
          on: {
            "keyup": _vm.trimMoreThan4Spaces,
            "blur": _vm.trimMoreThan4Spaces,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data.headerObj.gaps, index, $event.target.value)
            }
          }
        })])
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.headerObj.last))])], 2) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.BODY) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._l((data.bodyObj.text), function(part, index) {
        return _c('span', {
          key: 'body' + index,
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_vm._v(_vm._s(part)), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.bodyObj.gaps[index]),
            expression: "data.bodyObj.gaps[index]"
          }],
          staticStyle: {
            "margin-bottom": "4px",
            "width": "500px"
          },
          attrs: {
            "placeholder": "Enter text for body"
          },
          domProps: {
            "value": (data.bodyObj.gaps[index])
          },
          on: {
            "keyup": _vm.trimMoreThan4Spaces,
            "blur": _vm.trimMoreThan4Spaces,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data.bodyObj.gaps, index, $event.target.value)
            }
          }
        })])
      }), _c('span', [_vm._v(_vm._s(data.bodyObj.last))])], 2) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.FOOTER) ? _c('div', {
        staticClass: "nudge-whatsapp-footer"
      }, [_vm._v(_vm._s(data.turn_template_data.FOOTER))]) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.BUTTONS) ? _c('div', {
        staticStyle: {
          "margin-top": "5px"
        }
      }, _vm._l((data.buttonsObj), function(button, bIndex) {
        return _c('div', {
          key: 'button' + bIndex,
          staticClass: "nudge-whatsapp-button"
        }, [(button.text.length) ? [_vm._l((button.text), function(part, index) {
          return _c('span', {
            key: 'buttonPart' + index
          }, [_vm._v("\n                      " + _vm._s(part)), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (button.gaps[index]),
              expression: "button.gaps[index]"
            }],
            staticStyle: {
              "width": "300px"
            },
            attrs: {
              "placeholder": "Enter value for button link"
            },
            domProps: {
              "value": (button.gaps[index])
            },
            on: {
              "keyup": _vm.trimMoreThan4Spaces,
              "blur": _vm.trimMoreThan4Spaces,
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(button.gaps, index, $event.target.value)
              }
            }
          })])
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(button.last))])] : [_vm._v(_vm._s(button.label))]], 2)
      }), 0) : _vm._e(), _vm._v(" "), (!data.turn_template_data) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(" -- Not available in " + _vm._s(_vm.turnCountry) + " -- ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "nudge-origin-title",
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v("Facebook Nudge(s):")]), _vm._v(" "), _vm._l((_vm.nudgePreviewData), function(data, index) {
      return _c('div', {
        key: index,
        staticClass: "margin-bottom-10px"
      }, [_c('span', {
        staticClass: "nudge-language"
      }, [_vm._v(_vm._s(data.language) + " :")]), _vm._v(" "), (data.fb_nudge_text) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(_vm._s(data.fb_nudge_text))]) : _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(" -- No data available -- ")])])
    })], 2) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.turnCountry && _vm.isDynamicTemplate(_vm.groupList[_vm.previewGroupIndex].msg_template_id)) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveConfiguredNudgeData
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeNudgePreview
    }
  }, [_vm._v("Close")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Step 1 | Name your campaign\n                      "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "Please check if users are added manually"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("\n                    Step 2 | Select Audience"), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('label', {
    staticClass: "hint-text"
  }, [_vm._v("If you want to resume Journey, Destination MUST be Keyword = resume_replay")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "Checking this option will allow the creator of this campaign to send another question to the user. This question may be configured with one or more options. NOTE - This functionality has been created because the nudge itself asks the users press 1 to continue."
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("\n                    Step 4 | Scheduling "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "recurrence"
    }
  }, [_vm._v("Recurrence "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('label', {
    staticClass: "hint-text"
  }, [_vm._v("(Can the user see this once or many times?)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Inactivity timing "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('label', {
    staticClass: "hint-text"
  }, [_vm._v("(Cannot be greater than 23 hours. Sent within a 30 minute\n                                window from the selected time.)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "recurrence"
    }
  }, [_vm._v("Recurrence "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('label', {
    staticClass: "hint-text"
  }, [_vm._v("(Can the user see this once or many times?)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Inactivity timing "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "last_rem_days"
    }
  }, [_vm._v("Days from last REM"), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "hint-text"
  }, [_vm._v("(Engineers Only)")]), _vm._v(" Remove upperbound for inactivity timing")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "width": "calc( 100% - 50px)"
    }
  }, [_vm._v("\n                                Campaign Thresholds (Optional)\n                                "), _c('label', {
    staticClass: "hint-text"
  }, [_vm._v("(Set the limit to this campaign)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "max_templated_message"
    }
  }, [_vm._v("Max templated messages(nudges) per user"), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('label', {
    staticClass: "hint-text",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("(Valid for this campaign only)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "style-button-section"
  }, [_c('b', [_vm._v("Button")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-template-text"
  }, [_c('b', [_vm._v("Template to use button:- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "style-list-section"
  }, [_c('b', [_vm._v("List")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-template-text"
  }, [_c('b', [_vm._v("Template to use list:- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "style-list-section"
  }, [_c('b', [_vm._v("User Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-template-text"
  }, [_c('b', [_vm._v("Template to use user name:-(Currently, supported only for Ninety JoR) ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "style-list-section"
  }, [_c('b', [_vm._v("Provider Code")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-template-text"
  }, [_c('b', [_vm._v("Template to use provider code:-")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7d2d9771","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/opportunity-management/createOrUpdateOpportunity.vue
// module id = 158k
// module chunks = 1